// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@eisinc/Overrides/Widgets/OrderConfirmation/OrderConfirmationHeader";
import AddToList from "@eisinc/XDL/Icons/AddToList";
import ArrowRight from "@eisinc/XDL/Icons/ArrowRight";
import Print from "@eisinc/XDL/Icons/Print";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

headerStyles.title = {
    variant: "h1",
    css: css`
        &&& {
            margin-bottom: 16px;
        }
        @media print {
            font-size: 32px !important;
            margin-bottom: 0;
        }
    `,
};

headerStyles.buttonsHiddenContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
    `,
};

headerStyles.addToListLink = {
    icon: {
        iconProps: {
            size: 12,
            src: AddToList,
            css: css`
                opacity: 0.5;
            `,
        },
        position: "left",
    },
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
};

headerStyles.printLink = {
    icon: {
        iconProps: {
            size: 12,
            src: Print,
            css: css`
                opacity: 0.5;
            `,
        },
        position: "left",
    },
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
};

headerStyles.continueLink = {
    icon: {
        iconProps: {
            size: 12,
            src: ArrowRight,
            css: css`
                opacity: 0.5;
            `,
        },
        position: "left",
    },
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
};
